import dayjs from "dayjs";
import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const addValidationSchema = (
  t: TFunction,
  isEditMode: boolean = false,
  isNPIRequired?: string,
) => {
  return yup.lazy(() => {
    const schemaFields: yup.ObjectShape = {
      name: yup
        .string()
        .required("This field is required")
        .min(2, t("validations.min_length", { count: 2 }))
        .max(50, t("validations.max_length", { count: 50 })),
      groupLabelIds: yup
        .array()
        .of(yup.string())
        .transform((value) =>
          typeof value === "string" && value === "" ? [] : value,
        ),
      description: yup.string(),
      addressLine1: yup.string().required("This field is required"),
      addressLine2: yup.string(),
      city: yup.string().required("This field is required"),
      region: yup.string().required("This field is required"),
      zipCode: yup.string().required("This field is required"),
      contactName: yup.string().required("This field is required"),
      contactPhone: yup
        .string()
        .required("This field is required")
        .test("phoneNumber", t("validations.invalid_format"), (value) => {
          if (!value || value.trim() === "") return true;
          const phoneRegex = /^\(?\d{4}\)?[-. ]?\d{6}$/;
          return phoneRegex.test(value);
        }),
      npi: yup.string().when([], {
        is: () => isNPIRequired === "true", // TODO: settings should return the right type
        then: (schema) => schema.required(t("validations.required")),
        otherwise: (schema) => schema,
      }),
    };

    return yup.object().shape(schemaFields);
  });
};

export type AddOUFormData = InferType<ReturnType<typeof addValidationSchema>>;

export default addValidationSchema;
